<template>
  <el-tabs v-model="activeName" @tab-click="typeChange" class="tabs-box">
    <el-tab-pane label="课程元素统计" name="element">
      <el-dropdown @command="elementChange">
        <span class="el-dropdown-link">
          {{name + '--课程元素统计（' + typeEle + ')'}}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="month">{{name + '--课程元素统计（月度）'}}</el-dropdown-item>
          <el-dropdown-item command="quarter">{{name + '--课程元素统计（季度）'}}</el-dropdown-item>
          <el-dropdown-item command="year">{{name + '--课程元素统计（年度）'}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="total-box">次数总计：<span class="total">{{eleTotal}}</span>次</div>
      <div id="element" class="charts-box"></div>
    </el-tab-pane>
    <el-tab-pane label="课时统计" name="time">
      <el-dropdown @command="timeChange">
        <span class="el-dropdown-link">
          {{name + '--课时统计（' + typeTime + ')'}}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="XL">{{name + '--课时统计（训练课程）'}}</el-dropdown-item>
          <el-dropdown-item command="ZY">{{name + '--课时统计（中医诊疗）'}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="total-box">次数总计：<span class="total">{{timeTotal}}</span>次</div>
      <div id="time" class="charts-box"></div>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
export default {
  data() {
    return {
      activeName: "element",
      name: this.$route.query.name,
      id: this.$route.query.id,
      typeEle: "月度",
      dataEle: [],
      monthVal: [],
      hourVal: [],
      eleTotal: 0,
      timeTotal: 0,
      typeTime: "训练课程"
    };
  },
  mounted() {
    this.getElement("month");
  },
  methods: {
    typeChange(tab, event) {
      if (this.activeName == "element") {
        this.getElement("month");
        this.elementChange("month")
      } else {
        this.getTime("XL");
        this.timeChange("XL")
      }
    },
    initEle(value) {
      var eleChart = this.$echarts.init(document.getElementById("element"));
      eleChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left"
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: "55%",
            center: ["50%", "50%"],
            data: value,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      });
    },
    getElement(type) {
      var that = this;
      that.loading = true;
      that.dataEle = [];
      that.$axios
        .get(that.baseUrl + "/orderAdminElement", {
          params: {
            timeType: type,
            userId: this.id
          }
        })
        .then(res => {
          that.loading = false;
          that.dataEle = [];
          that.eleTotal = 0;
          let arr = res.data.data;
          arr.map(data => {
            let json = {
              value: data.countNum,
              name: data.courseName
            };
            that.dataEle.push(json);
            that.eleTotal += Number(data.countNum);
          });
          if (!that.dataEle.length) {
            that.dataEle = [
              {
                value: 1,
                name: "暂无训练"
              }
            ];
          }
          that.initEle(that.dataEle);
        })
        .catch(error => {
          that.loading = false;
          console.log(error);
        });
    },
    elementChange(command) {
      if (command == "month") {
        this.typeEle = "月度";
      } else if (command == "quarter") {
        this.typeEle = "季度";
      } else if (command == "year") {
        this.typeEle = "年度";
      }
      this.getElement(command);
    },
    // 课时统计
    initTime(data, value) {
      var timeChart = this.$echarts.init(document.getElementById("time"));
      console.log(data);
      console.log(value);
      timeChart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: {
          type: "category",
          data: data
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "课时（小时）",
            type: "bar",
            barWidth: "60%",
            data: value
          }
        ]
      });
    },
    getTime(type) {
      var that = this;
      that.loading = true;
      that.dataTime = [];
      that.$axios
        .get(that.baseUrl + "/orderAdminTime", {
          params: {
            courseType: type,
            userId: this.id
          }
        })
        .then(res => {
          that.loading = false;
          that.monthVal = [];
          that.hourVal = [];
          that.timeTotal = 0;
          let arr = res.data.data;
          arr.map(data => {
            that.monthVal.push(data.month + "月");
            that.hourVal.push(Number(data.hour).toFixed(1));
            that.timeTotal += Number(data.total);
          });
          if(!that.monthVal.length && !that.hourVal.length) {
            that.monthVal = ['暂无课时数据']
            that.hourVal = ['0']
          }
          that.initTime(that.monthVal, that.hourVal);
        })
        .catch(error => {
          that.loading = false;
          console.log(error);
        });
    },
    timeChange(command) {
      if (command == "XL") {
        this.typeTime = "训练课程";
      } else if (command == "ZY") {
        this.typeTime = "中医诊疗";
      }
      this.getTime(command);
    },
  }
};
</script>
<style scoped>
.tabs-box {
  padding: 0 20px;
  background: #fff;
  text-align: center;
}
.charts-box {
  width: 100%;
  height: 600px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  font-size: 20px;
  margin: 0 auto;
}
.el-icon-arrow-down {
  font-size: 20px;
}
.total-box {
  font-size: 20px;
}
.total-box .total {
  color: #e46b1a;
  padding-right: 10px;
}
</style>
